import React, { useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import moment from "moment";
import Spinner from "react-bootstrap/Spinner";

import afterLoginApiAxios from "../../Util/API Calls/afterLogin";

import "../UI Component/Modal/Modal.css";
import CloseIcon from "../../assets/close_icon.png";
import {
  disableHelpButton,
  enableHelpButton,
} from "../common/DisableHelpButton/DisableHelpButton";
import { C2CConsole } from "../../Util/Helper/C2CConsole";

var FontAwesome = require("react-fontawesome");

export default function ViewDetailsModalNew(props) {
  const [appointmentDetails, setAppointmentDetails] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (props.openView) {
      disableHelpButton();
      setLoading(true);
      fetchAppointmentDetails();
    }
    return () => {
      enableHelpButton();
    };
  }, [props.openView]);

  function fetchAppointmentDetails() {
    afterLoginApiAxios
      .post(
        "/doctor/get-appointment-details-by-id",
        { appointment_id: props.appointment_id },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("id_token"),
          },
        }
      )
      .then((response) => {
        C2CConsole.log(response);
        if (response.data) {
          if (response.data.statusCode == "200") {
            setAppointmentDetails(response.data.appointment_details);
            setLoading(false);
          } else {
            C2CConsole.log(response);
            setLoading(false);
            // TODO: Error handling and logging
          }
        } else {
          setLoading(false);
          // TODO: Error handling and logging
        }
      })
      .catch((err) => C2CConsole.log(err));
  }

  function renderAppointmentType(appointmentType) {
    switch (appointmentType) {
      case "in-clinic":
        return <span>In-Clinic</span>;
      case "online":
        return <span>Online</span>;
      default:
        return "";
    }
  }

  function renderConsultationType(
    appointmentType,
    consultationType,
    procedureName,
    allAppointmentProcedures
  ) {
    let appointmentTypeText =
      appointmentType === "in-clinic" ? "In-Clinic" : "Tele-Consult";
    switch (appointmentType) {
      case "online":
        if (consultationType === "instant") {
          return <span>Instant</span>;
        }
        if (consultationType === "followup") {
          return <span>{appointmentTypeText + " Follow-Up"}</span>;
        }
        return <span>{appointmentTypeText + " Regular"}</span>;
      case "regular":
        return <span>{appointmentTypeText + " Regular"}</span>;
      case "followup":
        return <span>{appointmentTypeText + " Follow-Up"}</span>;
      case "procedure":
        return <span>{procedureName}</span>;
      case "in-clinic":
        if (consultationType === "procedure") {
          return (
            <span>
              {allAppointmentProcedures !== ""
                ? allAppointmentProcedures
                : procedureName}
            </span>
          );
        }
        return (
          <span>
            {allAppointmentProcedures !== ""
              ? allAppointmentProcedures
              : appointmentTypeText + " Consultation"}
          </span>
        ); // fix for 7043
      default:
        return "";
    }
  }

  function renderPaymentMethod(payment_method, appointment_type, allPayment) {
    if (appointment_type === "online") {
      return "Online via C2C";
    } else {
      if (allPayment) {
        let dup = allPayment.split(",");
        let removeDup = dup.filter((c, index) => {
          return dup.indexOf(c) === index;
        });
        removeDup.map((data, index) => {
          if (data.toLowerCase() === "online") {
            removeDup[index] = "Online via C2C";
          } else if (data.toLowerCase().includes("cash")) {
            C2CConsole.log(
              "props?.appointmentStatus",
              props?.appointmentStatus
            );
            if (
              props?.appointmentStatus?.includes("rescheduled") ||
              props?.appointmentStatus?.includes("upcoming")
            ) {
              // return
              removeDup[index] = "Pay at Clinic";
            } else {
              removeDup[index] = "Paid at Clinic - By Cash";
            }
            // removeDup[index] = "Paid at Clinic - " + data; //{data}
          } else {
            removeDup[index] = `Paid at Clinic - ${data}`;
          }
        });
        let final_data = `${
          removeDup !== undefined &&
          removeDup.length > 0 &&
          removeDup.map((data) => data)
        }`;
        return final_data.replace(",", ", ");
      }
      //   if (allPayment !== undefined && allPayment.length > 0) {
      //     allPayment.map((element, i) => {
      //       if (element.toLowerCase() === "online") {
      //         allPayment[i] = "Online via C2C";
      //       }
      //       // else if (element.toLowerCase().trim() === "cash") {
      //       //   allPayment[i] = "Pay at Clinic - By Cash ";
      //       // }
      //       else {
      //         allPayment[i] = `Pay at Clinic - ${element}`;
      //       }
      //     });
      //   }
      // let data = `${
      //   allPayment !== undefined &&
      //   allPayment.length > 0 &&
      //   allPayment.map((data) => data)
      // }`;
      // return data.replace(",", ", ");
    }
  }

  const getAge = (date) => {
    let startDate = moment(date, "YYYY-MM-DD");
    let endDate = moment();
    const duration = moment.duration(endDate.diff(startDate));
    let displaydob = moment(date).format("DD MMM YYYY");
    let year =
      `${duration.years() != "0" ? duration.years() + " Years " : ""}` +
      `${duration.years() < "10" ? duration.months() + " Months " : ""}` +
      `${duration.years() < "1" ? duration.days() + " Days " : ""}`;
    return displaydob + "/" + year;
  };

  const getOnlyAge = (data) => {
    let arr = data.toLowerCase().split(" ");
    let age = "";
    if (arr.length >= 6) {
      let year = arr[0];
      let month = arr[2];
      let day = arr[4];
      if (year != "" && month != "" && day != "") {
        year = Number(year);
        month = Number(month);
        day = Number(day);
        if (year > 0) {
          if (year < 10) {
            age = year + " Years " + (month > 0 ? month + " Months" : "");
          } else {
            age = year + " Years";
          }
        } else {
          age =
            (month > 0 ? month + " Months " : "") +
            (day > 0 ? day + " Days " : "");
        }
      }
    }

    return age;
  };

  return (
    <>
      {props.openView ? (
        <Modal
          show={props.openView}
          onHide={props.closeView}
          className="view-details-modal"
          centered
        >
          <Modal.Header className="b-bottom">
            <Modal.Title className="w-100">
              <div className="d-flex justify-content-between heading">
                <h4 className="mb-0">Appointment Details</h4>
                <img
                  className="close_icon mt-2 cursor-pointer"
                  src={CloseIcon}
                  alt=""
                  onClick={props.closeView}
                />
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="view-detail">
            {loading ? (
              <div className="my-3 text-center">
                <Spinner animation="border" variant="secondary" />
              </div>
            ) : (
              <>
                <div className="row appt-time b-bottom">
                  {/* <div className="col-12">
                    <div className="d-flex justify-content-between">
                      <h4>Appointment Details</h4>
                      <img src={CloseIcon} alt="" onClick={props.closeView} />
                    </div>
                  </div> */}
                  <div className="col-12 py-3">
                    <p className="appt-time-content m-0">
                      <span
                        aria-hidden="true"
                        className="fa fa-calendar mr-1 iconSmall mr-2"
                      ></span>
                      {/* <br /> */}
                      <span>
                        {moment(appointmentDetails.appointment_date).format(
                          "MMM DD, YYYY"
                        )}
                        {" at "}
                        {moment(
                          appointmentDetails.appointment_start_time,
                          "hh:mmZ"
                        ).format("hh:mm A")}
                      </span>
                    </p>
                  </div>
                </div>
                <div className="row info">
                  <div className="col-6 mb-4">
                    <p className="label">Patient Name</p>
                    <p className="content">{appointmentDetails.patient_name}</p>
                  </div>
                  <div className="col-6 mb-4">
                    <p className="label">Date of Birth/Age</p>
                    <p className="content">
                      {" "}
                      {/* {appointmentDetails.patient_dob != ""
                        ? moment(appointmentDetails.patient_dob).format(
                            "DD MMM YYYY"
                          )
                        : "-"} */}
                      {appointmentDetails.patient_dob != "" &&
                        getAge(appointmentDetails.patient_dob)}
                      {appointmentDetails.patient_dob == "" &&
                        appointmentDetails.patient_age != "" &&
                        getOnlyAge(appointmentDetails.patient_age)}
                    </p>
                  </div>
                  <div className="col-6 mb-4">
                    <p className="label">Gender</p>
                    <p className="content">
                      {appointmentDetails.patient_gender}
                    </p>
                  </div>
                  <div className="col-6 mb-4">
                    <p className="label">Phone Number</p>
                    <p className="content">{appointmentDetails.phone_no}</p>
                  </div>
                  <div className="col-6 mb-4">
                    <p className="label">Purpose of Consultation</p>
                    <p className="content">
                      {appointmentDetails.purpose_of_appointment != ""
                        ? appointmentDetails.purpose_of_appointment
                        : "-"}
                    </p>
                  </div>
                  <div className="col-6 mb-4">
                    <p className="label">Payment Method</p>
                    <p className="content" style={{ textTransform: "none" }}>
                      {/* {appointmentDetails.payment_method === "cash"
                        ? "By Cash"
                        : appointmentDetails.payment_method} */}
                      {renderPaymentMethod(
                        appointmentDetails.payment_method,
                        appointmentDetails.appointment_type,
                        appointmentDetails.all_payment_mode
                      )}
                    </p>
                  </div>
                  <div className="col-12">
                    <p className="label">Consultation</p>
                    <p className="content">
                      {renderAppointmentType(
                        appointmentDetails.appointment_type
                      )}{" "}
                      :{" "}
                      {renderConsultationType(
                        appointmentDetails.appointment_type,
                        appointmentDetails.consultation_type,
                        appointmentDetails.procedure_name,
                        appointmentDetails.all_procedure_name
                      )}
                    </p>
                  </div>
                </div>
              </>
            )}
          </Modal.Body>
        </Modal>
      ) : null}
    </>
  );
}
